"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WAYFAIR_ALT_ID = exports.W9_EMPLOYERREPORT_ALT_ID = exports.USER_NOTIFICATION_TYPE = exports.USER_ACCOUNT_TYPES = exports.USER_ACCOUNT_OFFER_STATUS = exports.URLS = exports.TRANSPARENT_PIXEL_SRC = exports.TABLE_PAGE_SIZES = exports.SYSTEM_USER_GUID = exports.SPINWHEEL_STEP = exports.SPINWHEEL_PROGRESS_STEPPER_STEP = exports.SPINWHEEL_PAYMENT_TYPE_STATUS = exports.SPINWHEEL_LOAN_ACCOUNT_CONNECTION_STATUS = exports.SPINWHEEL_CONNECT_MODULE_ERROR_EVENTS = exports.SERVICER_TYPE = exports.SERVICER_ADDRESS_VALIDATION_STATUS = exports.RETURN_REISSUE_REASON_CODES = exports.REIMBURSEMENT_REQUIREMENT_TYPE = exports.REIMBURSEMENT_ITEM_INVALIDATION_REASON = exports.REIMBURSEMENT_INVALIDATION_REASON = exports.REIMBURSEMENT_EVENT_TYPE = exports.REIMBURSEMENT_EVENT_SUBMISSION_STATUS = exports.REIMBURSEMENT_EVENT_REQUIREMENT_TYPE = exports.REFI_SETUP_STATUS = exports.REFI_MAXIMUM_REWARD = exports.RADIUS_PROGRAM_ALT_ID = exports.PROGRAM_TYPES = exports.PROGRAM_SETUP_STATE = exports.PROGRAM_PAYMENT_TYPES = exports.PROGRAM_OCCURRENCE_TYPES = exports.PROGRAM_DROPDOWN_YEARS = exports.PROGRAM_CONTRIBUTION_TYPES = exports.PROGRAM_ACTIVATION_STATUS = exports.PRODUCT_TYPES = exports.PRODUCT_MODEL_STATE = exports.PAYMENT_ACCOUNT_TYPES = exports.PARTICIPANT_ENROLLMENT_STATUS = exports.PAGE_CONTEXT = exports.ONBOARDING_STEP = exports.NAME_MISMATCH_REASON = exports.META_TAG_TYPES = exports.MESSAGING_STRATEGIES = exports.MEFA_PROGRAM_ALT_ID = exports.MEFA_OFFER_ALT_ID = exports.MATCH_SUBMISSION_STEP = exports.MATCH_PAYMENT_WARNING_TYPE = exports.MATCH_PAYMENT_STATUS = exports.MATCH_PAYMENT_INVALIDATION_REASON = exports.MATCH_DUPLICATE_REASON = exports.MATCH_DOCUMENT_STATUS = exports.MATCH_DOCUMENT_INVALIDATION_REASON = exports.LOAN_TYPE = exports.LOAN_STATUS = exports.LOAN_AMOUNTS_SUMMARY = exports.LENDKEY_PROGRAM_ALT_ID = exports.LENDKEY_OFFER_ALT_ID = exports.LENDER_MEFA = exports.LENDER_LENDKEY = exports.LENDER_FRB = exports.LENDER_EARNEST = exports.KEYCODES = exports.JOB_TYPE = exports.INSUFFICIENT_FUNDS_DASHBOARD_ACTIONS = exports.INACTIVE_PAYMENT_ACCOUNT_STATUS = exports.IMAGE_SIZE = exports.IMAGE_CROP_STYLE = exports.GRADE_TYPE = exports.FREQUENCY_UNIT = exports.FRB_OFFER_ALT_ID = exports.FRB_LENDER_ALT_ID = exports.FORM_SUBMIT_DEBOUNCE_MS = exports.ENTITY_TYPES = exports.ENTITY_SLUG_TYPES = exports.ENTITY_PAYMENT_TYPES = exports.ENTITY_LOGO_BANNER_STYLE = exports.ENROLLMENT_STATUS = exports.ENROLLMENT_COMMUNICATION_TYPE = exports.EMPTY_GUID = exports.EMPLOYER_LAUNCH_STATE = exports.EMPLOYER_COMMUNICATION_TYPES = exports.EDUCATION_LEVEL = exports.EARNEST_PROGRAM_ALT_ID = exports.EARNEST_OFFER_ALT_ID = exports.EARNEST_LENDER_ALT_ID = exports.DEFAULT_CONFIG_SET_ALT_ID = exports.COURSE_GRADE = exports.CITIZENS_PROGRAM_ALT_ID = exports.CITIZENS_OFFER_ALT_ID = exports.CHANGE_REQUEST_TYPE = exports.CHANGE_REQUEST_STATUS = exports.CARD_IDS = exports.AVAILABLE_REPORT_IDS = exports.AECOM_ALT_ID = exports.ACCOUNT_REVIEW_STATUS = exports.ACCEPTED_UPLOAD_FILE_TYPES = void 0;

/**
 * A place for sharing
 */
var EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
exports.EMPTY_GUID = EMPTY_GUID;
var SYSTEM_USER_GUID = "12312312-1231-1231-1231-123123123123";
exports.SYSTEM_USER_GUID = SYSTEM_USER_GUID;
var REFI_MAXIMUM_REWARD = 300;
exports.REFI_MAXIMUM_REWARD = REFI_MAXIMUM_REWARD;
var FORM_SUBMIT_DEBOUNCE_MS = 500;
exports.FORM_SUBMIT_DEBOUNCE_MS = FORM_SUBMIT_DEBOUNCE_MS;
var DEFAULT_CONFIG_SET_ALT_ID = "8377640b-518a-4338-840d-7a855ca380d8";
exports.DEFAULT_CONFIG_SET_ALT_ID = DEFAULT_CONFIG_SET_ALT_ID;
var TRANSPARENT_PIXEL_SRC = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
exports.TRANSPARENT_PIXEL_SRC = TRANSPARENT_PIXEL_SRC;
var CITIZENS_PROGRAM_ALT_ID = "94a2ac73-6bf2-4404-9af7-62c3702931c4";
exports.CITIZENS_PROGRAM_ALT_ID = CITIZENS_PROGRAM_ALT_ID;
var CITIZENS_OFFER_ALT_ID = "ab0db293-cc11-4fd4-9343-1a5893c7a21b";
exports.CITIZENS_OFFER_ALT_ID = CITIZENS_OFFER_ALT_ID;
var RADIUS_PROGRAM_ALT_ID = "20e5d571-588d-494e-8953-073bb48994f8";
exports.RADIUS_PROGRAM_ALT_ID = RADIUS_PROGRAM_ALT_ID;
var FRB_OFFER_ALT_ID = "81f2833c-f8d2-493b-9e33-7c7ab3c6cef2";
exports.FRB_OFFER_ALT_ID = FRB_OFFER_ALT_ID;
var LENDKEY_OFFER_ALT_ID = "18c7d441-caaa-46d1-8285-106d0c099b48";
exports.LENDKEY_OFFER_ALT_ID = LENDKEY_OFFER_ALT_ID;
var LENDKEY_PROGRAM_ALT_ID = "eb56521b-2c40-4aad-ba77-bcab167a0092";
exports.LENDKEY_PROGRAM_ALT_ID = LENDKEY_PROGRAM_ALT_ID;
var EARNEST_OFFER_ALT_ID = "a453b9b9-9232-4ae8-9333-243772bee53c";
exports.EARNEST_OFFER_ALT_ID = EARNEST_OFFER_ALT_ID;
var EARNEST_PROGRAM_ALT_ID = "ece4012c-98c5-4d62-b57c-50dfa2e29f0f";
exports.EARNEST_PROGRAM_ALT_ID = EARNEST_PROGRAM_ALT_ID;
var MEFA_OFFER_ALT_ID = "764ba32d-eeda-4afb-be8b-ebd3fd5d5ec9";
exports.MEFA_OFFER_ALT_ID = MEFA_OFFER_ALT_ID;
var MEFA_PROGRAM_ALT_ID = "1e5ccb26-dd5e-44ec-be61-43bfefde40c3";
exports.MEFA_PROGRAM_ALT_ID = MEFA_PROGRAM_ALT_ID;
var FRB_LENDER_ALT_ID = "d6811850-3584-4ce4-ace7-69dfbf0ff789";
exports.FRB_LENDER_ALT_ID = FRB_LENDER_ALT_ID;
var EARNEST_LENDER_ALT_ID = "b9500b8e-8578-4690-abc9-f102c4affb6c";
exports.EARNEST_LENDER_ALT_ID = EARNEST_LENDER_ALT_ID;
var LENDER_EARNEST = "earnest";
exports.LENDER_EARNEST = LENDER_EARNEST;
var LENDER_LENDKEY = "lendkey";
exports.LENDER_LENDKEY = LENDER_LENDKEY;
var LENDER_FRB = "frb";
exports.LENDER_FRB = LENDER_FRB;
var LENDER_MEFA = "mefa";
exports.LENDER_MEFA = LENDER_MEFA;
var PROGRAM_DROPDOWN_YEARS = 10;
exports.PROGRAM_DROPDOWN_YEARS = PROGRAM_DROPDOWN_YEARS;
var WAYFAIR_ALT_ID = "324933b7-11fd-4ec7-a5c0-e28d536c382e";
exports.WAYFAIR_ALT_ID = WAYFAIR_ALT_ID;
var AECOM_ALT_ID = "6e7f5cb4-f40b-4218-bf28-5b5794d995ff";
exports.AECOM_ALT_ID = AECOM_ALT_ID;
var W9_EMPLOYERREPORT_ALT_ID = "40a19b24-5043-43b0-9d56-731c433f28dd";
exports.W9_EMPLOYERREPORT_ALT_ID = W9_EMPLOYERREPORT_ALT_ID;
var PAGE_CONTEXT = {
  EMPLOYER: {
    MANAGE_PROGRAMS: 0,
    PROGRAM_DETAIL: 1
  }
};
exports.PAGE_CONTEXT = PAGE_CONTEXT;
var EMPLOYER_LAUNCH_STATE = {
  NEEDS_PROGRAMS: 0,
  NEEDS_PARTICIPANTS: 1,
  NEEDS_PROGRAM_ACTIVATIONS: 2,
  NEEDS_INVITATIONS: 3,
  UP_TO_DATE: 4
}; // corresponds with server enum PaymentAccountType.cs
// TODO GR-5888 does not match server enum name

exports.EMPLOYER_LAUNCH_STATE = EMPLOYER_LAUNCH_STATE;
var PAYMENT_ACCOUNT_TYPES = {
  LOAN: 0,
  FIVE_TWENTY_NINE: 1
}; // see enum defined in ValidationStatus.cs

exports.PAYMENT_ACCOUNT_TYPES = PAYMENT_ACCOUNT_TYPES;
var SERVICER_ADDRESS_VALIDATION_STATUS = {
  UNVALIDATED: 0,
  VALID: 1,
  KNOWN: 2,
  INDIVIDUAL: 3,
  NO_STUDENT_LOANS: 4,
  NOT_IN_US: 5,
  INVALID: 6,
  NO_529_PLAN_ACCOUNTS: 7,
  NOT_529_DIRECT_PLAN: 8
}; // corresponds with server enum FrequencyUnit

exports.SERVICER_ADDRESS_VALIDATION_STATUS = SERVICER_ADDRESS_VALIDATION_STATUS;
var FREQUENCY_UNIT = {
  NONE: 0,
  MONTH: 1,
  QUARTER: 2,
  YEAR: 3,
  WEEK: 4,
  BIWEEK: 5,
  BIMONTH: 6,
  SECOND: 7,
  MINUTE: 8,
  HOUR: 9,
  DAY: 10
}; // corresponds with server enum ProgramType.cs
// TODO GR-5888 does not match server enum name

exports.FREQUENCY_UNIT = FREQUENCY_UNIT;
var PROGRAM_TYPES = {
  REFI: 0,
  // TODO GR-5888 value does not exist on the server
  SLP: 1,
  SPONSOR: 2,
  SAVEUP: 4,
  CHOICE: 8,
  TUITION: 16
}; // corresponds with server enum ProgramPaymentType.cs
// TODO GR-5888 does not match server enum name

exports.PROGRAM_TYPES = PROGRAM_TYPES;
var PROGRAM_PAYMENT_TYPES = {
  FIXED: 1,
  STEP: 2,
  TENURE: 3,
  DEDUCTION: 4
};
exports.PROGRAM_PAYMENT_TYPES = PROGRAM_PAYMENT_TYPES;
var PROGRAM_CONTRIBUTION_TYPES = {
  NONE: 0,
  SET_AMOUNT: 1,
  CUSTOM_AMOUNT: 2,
  DEDUCTION_AMOUNT: 3,
  MATCH_AMOUNT: 4,
  SECURE_MATCH: 5
};
exports.PROGRAM_CONTRIBUTION_TYPES = PROGRAM_CONTRIBUTION_TYPES;
var PROGRAM_OCCURRENCE_TYPES = {
  NONE: 0,
  SET: 1,
  ONGOING: 2,
  ONE_TIME: 3
};
exports.PROGRAM_OCCURRENCE_TYPES = PROGRAM_OCCURRENCE_TYPES;
var PROGRAM_ACTIVATION_STATUS = {
  REQUIRES_PARTICIPANTS: 1,
  READY_FOR_ACTIVATION: 2,
  REMINDERS_PENDING: 3,
  ACTIVE: 4,
  COMPLETED: 5
}; // corresponds with server enum ProductType.cs
// TODO GR-5888 does not match server enum name

exports.PROGRAM_ACTIVATION_STATUS = PROGRAM_ACTIVATION_STATUS;
var PRODUCT_TYPES = {
  // TODO GR-5888 Missing ProductType.None
  PAYDOWN: 1,
  SAVEUP: 2,
  ASA: 4,
  CHOICE: 8,
  REFI: 16,
  TUITION: 64 // TODO GR-5888 Missing ProductType.LearningCenter

}; // corresponds with server enum EntityPaymentType.cs
// TODO GR-5888 does not match server enum name

exports.PRODUCT_TYPES = PRODUCT_TYPES;
var ENTITY_PAYMENT_TYPES = {
  NONE: 0,
  ACH_CREDIT: 1,
  ACH_DEBIT: 2,
  WIRE: 3
}; // corresponds with server enum EnrollmentStatus.cs

exports.ENTITY_PAYMENT_TYPES = ENTITY_PAYMENT_TYPES;
var ENROLLMENT_STATUS = {
  NONE: 0,
  // TODO GR-5888 Server value is EnrollmenStatus.All
  INELIGIBLE: 1,
  ELIGIBLE: 2,
  REGISTERED: 3,
  ENROLLED: 4,
  UNENROLLED: 5
}; // corresponds with server-side enum EducationLevel.cs

exports.ENROLLMENT_STATUS = ENROLLMENT_STATUS;
var EDUCATION_LEVEL = {
  ASSOCIATES: 1,
  BACHELORS: 2,
  MASTERS: 3,
  DOCTORATE: 4
};
exports.EDUCATION_LEVEL = EDUCATION_LEVEL;
var ONBOARDING_STEP = {
  WELCOME: 0,
  LOAN_AMOUNTS: 1,
  LOAN_ATTESTATION: 2,
  ADD_LOAN: 3,
  CONGRATULATIONS: 4,
  DO_YOU_HAVE_529: 5,
  ADD_529: 6,
  PRIMARY_GOAL: 7,
  SPINWHEEL_WIZARD: 8
};
exports.ONBOARDING_STEP = ONBOARDING_STEP;
var SPINWHEEL_STEP = {
  LAUNCH_STEP: 0,
  LOAN_ATTESTATION_STEP: 1,
  CONNECT_LOAN_DISCLAIMER_STEP: 2,
  CONNECT_LOAN_MODULE_STEP: 3,
  VERIFY_LOANS_STEP: 4,
  ACKNOWLEDGE_STEP: 5,
  FINALIZE_STEP: 6,
  POST_SUCCESS_STEP: 7
};
exports.SPINWHEEL_STEP = SPINWHEEL_STEP;
var SPINWHEEL_PROGRESS_STEPPER_STEP = {
  CONNECT_STEP: 0,
  VERIFY_STEP: 1,
  FINALIZE_STEP: 2,
  POST_SUCCESS_STEP: 3
};
exports.SPINWHEEL_PROGRESS_STEPPER_STEP = SPINWHEEL_PROGRESS_STEPPER_STEP;
var MATCH_SUBMISSION_STEP = {
  WELCOME_STEP: 0,
  LOAN_SELECTOR_STEP: 1,
  AGGREGATED_TRANSACTION_STEP: 2,
  UPLOAD_DOCUMENTATION_STEP: 3,
  RESUBMIT_DOCUMENTATION_STEP: 4,
  REVISE_DOCUMENTATION_STEP: 5,
  MANUAL_PAYMENT_ENTRY_STEP: 6,
  REVIEW_STEP: 7,
  SPINWHEEL_REVIEW_STEP: 8,
  ACKNOWLEDGE_STEP: 9
};
exports.MATCH_SUBMISSION_STEP = MATCH_SUBMISSION_STEP;
var SPINWHEEL_CONNECT_MODULE_ERROR_EVENTS = {
  API_TIMEOUT: "API_TIMEOUT",
  DIM_ERROR: "DIM_ERROR",
  DIM_UNAVAILABLE_OUTAGE: "DIM_UNAVAILABLE_OUTAGE",
  INVALID_TOKEN: "INVALID_TOKEN",
  EXPIRED_TOKEN: "EXPIRED_TOKEN"
};
exports.SPINWHEEL_CONNECT_MODULE_ERROR_EVENTS = SPINWHEEL_CONNECT_MODULE_ERROR_EVENTS;
var SPINWHEEL_LOAN_ACCOUNT_CONNECTION_STATUS = {
  NONE: 0,
  PENDING_ACCEPTANCE: 1,
  CONNECTED: 2,
  NEEDS_REAUTHENTICATION: 3,
  DISCONNECTED: 4
}; // corresponds with server enum ProgramSetupState.cs

exports.SPINWHEEL_LOAN_ACCOUNT_CONNECTION_STATUS = SPINWHEEL_LOAN_ACCOUNT_CONNECTION_STATUS;
var PROGRAM_SETUP_STATE = {
  NO_PARTICIPANTS: 1,
  UNACTIVATED: 2,
  // TODO GR-5888 Server value is ProgramSetupState.AwaitingActivation
  SETUP_COMPLETE: 3,
  SETUP_COMPLETE_WITH_SLUG: 4
}; // corresponds with server enum ParticipantEnrollmentStatus.cs

exports.PROGRAM_SETUP_STATE = PROGRAM_SETUP_STATE;
var PARTICIPANT_ENROLLMENT_STATUS = {
  NOT_REGISTERED: 0,
  NOT_ENROLLED: 1,
  PENDING: 2,
  ENROLLED: 3
}; // corresponds with server enum EmployerCommunicationType.cs

exports.PARTICIPANT_ENROLLMENT_STATUS = PARTICIPANT_ENROLLMENT_STATUS;
var EMPLOYER_COMMUNICATION_TYPES = {
  NEW_USER_INVITATION: 1,
  EXISTING_USER_INVITATION: 2,
  REMINDER: 3,
  PROGRAM_NOTIFICATION: 4,
  WELCOME_STREAM: 5
}; // corresponds with server enum EmployerRefiSetupStatus.cs

exports.EMPLOYER_COMMUNICATION_TYPES = EMPLOYER_COMMUNICATION_TYPES;
var REFI_SETUP_STATUS = {
  NONE: 0,
  NO_PARTICIPANTS: 1,
  UNACTIVATED: 2,
  PENDINGREMINDERS: 3,
  CUSTOM_URL_SETUP: 4,
  NO_PENDING_INVITATIONS: 5
}; // corresponds with server enum EnrollmentCommunicationType.cs

exports.REFI_SETUP_STATUS = REFI_SETUP_STATUS;
var ENROLLMENT_COMMUNICATION_TYPE = {
  NEW_USER: 1,
  EXISTING_USER: 2,
  REMINDER: 3
}; // corresponds with server enum EntityLogoBannerStyle.cs

exports.ENROLLMENT_COMMUNICATION_TYPE = ENROLLMENT_COMMUNICATION_TYPE;
var ENTITY_LOGO_BANNER_STYLE = {
  DARK_CIRCLE_CROP: 1,
  LIGHT_NO_CROP: 2
};
exports.ENTITY_LOGO_BANNER_STYLE = ENTITY_LOGO_BANNER_STYLE;
var IMAGE_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.IMAGE_SIZE = IMAGE_SIZE;
var IMAGE_CROP_STYLE = {
  CROPPED: "cropped",
  FULL: "full"
};
exports.IMAGE_CROP_STYLE = IMAGE_CROP_STYLE;
var ENTITY_TYPES = {
  COMPANY: "Company",
  LENDER: "Lender",
  PARTNER: "Partner",
  ALUMNI_ASSOCIATION: "AlumniAssociation",
  VENDOR: "Vendor",
  SERVICER: "Servicer",
  INTERNAL: "Internal",
  SPONSOR: "Sponsor"
};
exports.ENTITY_TYPES = ENTITY_TYPES;
var ACCEPTED_UPLOAD_FILE_TYPES = {
  STUDENT_LOAN: ["image/*", "application/pdf", ".doc", ".docx"],
  FIVE_TWENTY_NINE: ["image/*", "application/pdf", ".doc", ".docx"],
  MATCH: ["application/pdf", ".png", ".jpg", ".jpeg", ".jpe", ".jfif"],
  PARTICIPANT_UPLOAD: [".xlsm"]
}; // corresponds with server enum UserNotificationType.cs

exports.ACCEPTED_UPLOAD_FILE_TYPES = ACCEPTED_UPLOAD_FILE_TYPES;
var USER_NOTIFICATION_TYPE = {
  NEW_PROGRAM_MATCH: "NewProgramMatch",
  UNOFFICIAL_MATCH_SUBMISSION_DOCUMENT: "UnofficialMatchSubmissionDocument",
  MISSING_ACCOUNT_NUMBER_MATCH_SUBMISSION_DOCUMENT: "MissingAccountNumberMatchSubmissionDocument",
  INSUFFICIENT_MATCH_SUBMISSION_DOCUMENT: "InsufficientMatchSubmissionDocument",
  UNREADABLE_MATCH_SUBMISSION_DOCUMENT: "UnreadableMatchSubmissionDocument",
  MATCH_PAYMENT_DATE_INVALID: "MatchPaymentDateInvalid",
  MATCH_SCHEDULED_PAYMENT_INVALID: "MatchScheduledPaymentInvalid",
  MATCH_PAYMENT_AMOUNT_INVALID: "MatchPaymentAmountInvalid",
  MATCH_PAYMENT_NOT_LISTED: "MatchPaymentNotListed",
  MATCH_MULTIPLE_INVALID_PAYMENTS: "MatchMultipleInvalidPayments",
  APPROVED_MATCH_DOCUMENT_SUBMISSION: "ApprovedMatchDocumentSubmission",
  MATCH_SUBMISSION_REMINDER: "MatchSubmissionReminder",
  MATCH_LOAN_REMINDER: "MatchLoanReminder",
  MATCH_PAYMENT_OVERVIEW: "MatchPaymentOverview",
  MATCH_TRANSACTION_NOT_ELIGIBLE: "MatchTransactionNotEligible"
}; // corresponds with server enum ServicerType.cs

exports.USER_NOTIFICATION_TYPE = USER_NOTIFICATION_TYPE;
var SERVICER_TYPE = {
  STUDENT_LOAN: 1,
  FIVE_TWENTY_NINE: 2
}; // corresponds with server enum ReasonCodes.cs
// TODO GR-5888 does not match server enum name

exports.SERVICER_TYPE = SERVICER_TYPE;
var RETURN_REISSUE_REASON_CODES = {
  NO_REASON: 0,
  INVALID_SERVICER_ADDRESS: 1,
  INVALID_LOAN_ACCOUNT: 2,
  PAID_IN_FULL: 3,
  OTHER: 4,
  BOUNCED_CHECK: 5,
  UNABLE_TO_PROCESS: 6,
  LOST_PAYMENT: 7,
  FAILED_TO_POST: 8
}; // corresponds with server enum EntitySlugType.cs

exports.RETURN_REISSUE_REASON_CODES = RETURN_REISSUE_REASON_CODES;
var ENTITY_SLUG_TYPES = {
  USER_ACCOUNT_EXTERNAL_ID_LOOKUP: 1,
  UP_FRONT_REGISTRATION: 2,
  DEFERRED_REGISTRATION: 3 // TODO GR-5888 Server value is EntitySlugType.DeferredPortal

}; // corresponds with server enum NameMismatchReason.cs

exports.ENTITY_SLUG_TYPES = ENTITY_SLUG_TYPES;
var NAME_MISMATCH_REASON = {
  THIS_IS_MY_LEGAL_NAME: 1,
  // TODO GR-5888 Server value is NameMismatchReason.ThisIsLegalName
  I_HAVE_LEGALLY_CHANGED_MY_NAME: 2,
  // TODO GR-5888 Server value is NameMismatchReason.LegallyChangedName
  OTHER: 3
};
exports.NAME_MISMATCH_REASON = NAME_MISMATCH_REASON;
var USER_ACCOUNT_OFFER_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  WITHDRAWN: 2,
  ACCEPTED: 3,
  REJECTED: 4,
  EXPIRED: 5
};
exports.USER_ACCOUNT_OFFER_STATUS = USER_ACCOUNT_OFFER_STATUS;
var USER_ACCOUNT_TYPES = {
  PERSONAL: 0,
  MEMBER: 1,
  SELF_ATTESTED: 7,
  DEFERRED: 8
}; // corresponds with server enum MessagingStrategy.cs
// TODO GR-5888 does not match server enum name

exports.USER_ACCOUNT_TYPES = USER_ACCOUNT_TYPES;
var MESSAGING_STRATEGIES = {
  UNKNOWN: 0,
  REQUEST_WITH_TARGET: 1,
  REQUEST_WITH_SMS_TARGET: 2,
  REQUEST_WITH_STRING: 3,
  REQUEST_AND_CONFIG_KEY: 4,
  BULK_REQUEST_WITH_TARGET: 5,
  BULK_REQUEST_WITH_DERIVED_TARGET: 6
};
exports.MESSAGING_STRATEGIES = MESSAGING_STRATEGIES;
var TABLE_PAGE_SIZES = [10, 25, 50];
exports.TABLE_PAGE_SIZES = TABLE_PAGE_SIZES;
var LOAN_AMOUNTS_SUMMARY = {
  SUMMARY: 0,
  RATE: 1,
  BALANCE: 2,
  TERM: 3,
  TOTAL_INTEREST: 4,
  MONTHLY_PAYMENT: 5
}; // corresponds with LoanStatus.cs

exports.LOAN_AMOUNTS_SUMMARY = LOAN_AMOUNTS_SUMMARY;
var LOAN_STATUS = {
  NONE: 0,
  ACTIVE: 1,
  PAID: 2,
  INVALID: 3,
  UNDER_REVIEW: 4,
  TRANSFERRED: 5,
  REFINANCED: 6,
  SERVICER_FEEDBACK_INVALID: 7
}; // corresponds with InactivePaymentAccountStatus.cs

exports.LOAN_STATUS = LOAN_STATUS;
var INACTIVE_PAYMENT_ACCOUNT_STATUS = {
  PENDING: 1,
  PAID_OFF: 2,
  INVALID: 3,
  PROHIBITED: 4,
  UNDER_REVIEW: 6,
  LIMIT_REACHED: 7,
  DELETED: 8,
  TRANSFERRED: 9,
  REFINANCED: 10,
  SERVICER_FEEDBACK_INVALID: 11,
  ON_HOLD: 12,
  LIMITED: 13
};
exports.INACTIVE_PAYMENT_ACCOUNT_STATUS = INACTIVE_PAYMENT_ACCOUNT_STATUS;
var ACCOUNT_REVIEW_STATUS = {
  PENDING: 0,
  REVIEWED: 1
};
exports.ACCOUNT_REVIEW_STATUS = ACCOUNT_REVIEW_STATUS;
var AVAILABLE_REPORT_IDS = {
  MEMBER_REFI_LIABILITY: 1,
  PAYABLES_BALANCE_DETAILS: 2,
  PAYABLES_BALANCE_PAYMENT_TOTALS: 3,
  PAYABLES_BALANCE_TOTALS: 4,
  PAYABLES_BALANCE_TOTALS_BY_TYPE: 5,
  MONTHLY_MEMBER_LIABILITY: 6,
  UNAPPROVED_STATEMENTS: 7,
  LOAN_VERIFICATION_BY_ENTITY: 8,
  LOAN_VERIFICATION_BY_USER: 9
};
exports.AVAILABLE_REPORT_IDS = AVAILABLE_REPORT_IDS;
var CHANGE_REQUEST_STATUS = {
  PENDING: 0,
  UNDER_REVIEW: 1,
  CANCELLED: 2,
  ACCEPTED: 3,
  REJECTED: 4
};
exports.CHANGE_REQUEST_STATUS = CHANGE_REQUEST_STATUS;
var CHANGE_REQUEST_TYPE = {
  ADD_SERVICER_ADDRESS: 0,
  UPDATE_SERVICER_ADDRESS: 1,
  ADD_SERVICER: 2,
  UPDATE_SERVICER: 3,
  DELETE_SERVICER: 4,
  ADD_OFFER_RATE: 5,
  UPDATE_OFFER_RATE: 6,
  DELETE_OFFER_RATE: 7,
  ADD_ACH_PAYMENT_INFO: 8,
  UPDATE_ACH_PAYMENT_INFO: 9,
  UPDATE_SERVICER_ADDRESS_PAYMENT_SETTINGS: 10,
  OVERRIDE_SERVICER_ADDRESS: 11,
  DISABLE_ENTITY: 12,
  UPDATE_ENTITY_FEES: 13,
  UPDATE_ENTITY_PRODUCTS: 14,
  UPDATE_ENTITY_RESTRICTIONS: 15,
  ADD_ENTITY_SLUG: 16,
  DELETE_ENTITY_SLUG: 17,
  ACTIVATE_ENTITY_SLUG: 18,
  ADD_SLUG_DOMAIN: 19,
  DELETE_SLUG_DOMAIN: 20,
  OVERRIDE_EMAIL_TEMPLATE: 21,
  UPDATE_VARIABLE_RATE: 22,
  CREATE_PAYABLE_RETURN: 23,
  FIVE_TWENTY_NINE_PLAN_CHANGES: 24,
  ADMIN_OVERRIDE_USER_LOAN_ACCOUNT: 25,
  UPDATE_SERVICER_ADDRESS_ACCOUNT_NUMBER_VALIDATION: 26,
  SPINWHEEL_PAYMENT_TYPE_MAPPING_CHANGES: 27,
  BULK_EDIT_CHANGES: 28,
  UPDATE_EARNEST_REFINANCING_RATES: 29
};
exports.CHANGE_REQUEST_TYPE = CHANGE_REQUEST_TYPE;
var PRODUCT_MODEL_STATE = {
  ACTIVE_PROGRAM_ZERO_STATE: 0,
  PAID_OFF_ACCOUNT: 1,
  HISTORICAL_PROGRAM: 2,
  IMPACT_VIEW: 3
};
exports.PRODUCT_MODEL_STATE = PRODUCT_MODEL_STATE;
var INSUFFICIENT_FUNDS_DASHBOARD_ACTIONS = {
  SELECT_OPTION: 0,
  SPEAK_TO_SOMEONE: 1,
  LEARN_ABOUT_CURRENT_PROGRAM: 2,
  VIEW_FINANCING_OPTIONS: 3,
  EXPLORE_INFORMATIONAL_RESOURCES: 4
};
exports.INSUFFICIENT_FUNDS_DASHBOARD_ACTIONS = INSUFFICIENT_FUNDS_DASHBOARD_ACTIONS;
var CARD_IDS = {
  SPEAK_WITH_ASA: 0,
  CONTACT_LOAN_SERVICER: 1,
  VIEW_LEARNING_MODULES: 2,
  READ_PAYMENT_TYPES: 3,
  COMPARE_REFINANCE: 4,
  AVOID_DEFAULT_GUIDE: 5,
  KNOW_YOUR_OPTIONS: 6,
  VISIT_LEARNING_CENTER: 7,
  EXPLORE_CFPB_OPTIONS: 8,
  VIEW_FSA_LEARNING: 9
}; // corresponds with enum LoanType.cs

exports.CARD_IDS = CARD_IDS;
var LOAN_TYPE = {
  NONE: 0,
  FEDERAL_STAFFORD: 1,
  FEDERAL_CONSOLIDATION: 2,
  FEDERAL_PLUS_GRADUATE: 4,
  FEDERAL_PLUS_PARENT: 8,
  FEDERAL_PERKINS: 16,
  PRIVATE: 32,
  PRIVATE_PARENT: 64,
  UNKNOWN: 128
}; // corresponds with DocumentStatuses.cs

exports.LOAN_TYPE = LOAN_TYPE;
var MATCH_DOCUMENT_STATUS = {
  MAKER_PENDING: 0,
  MAKER_IN_PROGRESS: 1,
  CHECKER_PENDING: 2,
  CHECKER_IN_PROGRESS: 3,
  COMPLETED: 4
}; // corresponds with DocumentInvalidationReason.cs

exports.MATCH_DOCUMENT_STATUS = MATCH_DOCUMENT_STATUS;
var MATCH_DOCUMENT_INVALIDATION_REASON = {
  DOCUMENT_INVALID: 1,
  DOCUMENT_UNOFFICIAL: 2,
  DOCUMENT_UNREADABLE: 3,
  MISSING_ACCOUNT_NUMBER: 8
}; // corresponds with DocumentSubmissionItemInvalidationReason.cs

exports.MATCH_DOCUMENT_INVALIDATION_REASON = MATCH_DOCUMENT_INVALIDATION_REASON;
var MATCH_PAYMENT_INVALIDATION_REASON = {
  AMOUNT_INVALID: 4,
  DATE_INVALID: 5,
  PAYMENT_NOT_LISTED: 6,
  SCHEDULED_PAYMENT: 7,
  TRANSACTION_NOT_ELIGIBLE_FOR_MATCH: 9
}; // corresponds with ReimbursementEventSubmissionInvalidationReason.cs

exports.MATCH_PAYMENT_INVALIDATION_REASON = MATCH_PAYMENT_INVALIDATION_REASON;
var REIMBURSEMENT_INVALIDATION_REASON = {
  IncorrectInfo: 0,
  InvalidDocumentation: 1,
  Ineligible: 2,
  NotJustified: 3,
  NonCompliant: 4,
  Unspecified: 5,
  NoLongerEligible: 6
}; // corresponds with ReimbursementEventSubmissionItemInvalidationReason.cs

exports.REIMBURSEMENT_INVALIDATION_REASON = REIMBURSEMENT_INVALIDATION_REASON;
var REIMBURSEMENT_ITEM_INVALIDATION_REASON = {
  IncorrectInfo: 0,
  InvalidDocumentation: 1,
  Ineligible: 2,
  NotJustified: 3,
  NonCompliant: 4,
  AmountInvalid: 5,
  DateInvalid: 6,
  Unspecified: 7,
  NoLongerEligible: 8
}; // corresponds with DocumentSubmissionItemStatuses.cs

exports.REIMBURSEMENT_ITEM_INVALIDATION_REASON = REIMBURSEMENT_ITEM_INVALIDATION_REASON;
var MATCH_PAYMENT_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2,
  COMPLETED: 3
}; // corresponds with select options created in SelectViewModelBuilder.CreateDuplicateSubmissionReasonSelect

exports.MATCH_PAYMENT_STATUS = MATCH_PAYMENT_STATUS;
var MATCH_DUPLICATE_REASON = {
  SEPARATE_PAYMENTS: 0,
  DIFFERENT_CONTRIBUTER: 1,
  OTHER: 2
}; // corresponds with DocumentSubmissionItemWarningType.cs

exports.MATCH_DUPLICATE_REASON = MATCH_DUPLICATE_REASON;
var MATCH_PAYMENT_WARNING_TYPE = {
  DUPLICATE_PAYMENT: 0,
  EXISTING_CONTRIBUTION: 1,
  POSSIBLE_REVERSAL: 2
}; // corresponds with MetaTagTypes.cs

exports.MATCH_PAYMENT_WARNING_TYPE = MATCH_PAYMENT_WARNING_TYPE;
var META_TAG_TYPES = {
  SAVEUP: 0,
  PAYDOWN: 1,
  MATCH: 2,
  PROGRAMUPDATE: 3,
  REMINDER: 4
}; // cooresponds with SpinwheelPaymentTypeStatus.cs

exports.META_TAG_TYPES = META_TAG_TYPES;
var SPINWHEEL_PAYMENT_TYPE_STATUS = {
  NONE: 0,
  ELIGIBLE: 1,
  INELIGIBLE: 2,
  REQUIRESREVIEW: 3
}; // corresponds with server enum ReimbursementEventType.cs

exports.SPINWHEEL_PAYMENT_TYPE_STATUS = SPINWHEEL_PAYMENT_TYPE_STATUS;
var REIMBURSEMENT_EVENT_TYPE = {
  TUITION: 0,
  MEMBERSHIP: 1,
  CONFERENCE: 2,
  EXAM: 3,
  CERTIFICATION: 4,
  PROFESSIONAL_DEVELOPMENT: 5,
  OTHER: 6
}; // corresponds with server enum ReimbursementEventRequirementType.cs

exports.REIMBURSEMENT_EVENT_TYPE = REIMBURSEMENT_EVENT_TYPE;
var REIMBURSEMENT_EVENT_REQUIREMENT_TYPE = {
  NAME: 0,
  COURSE_NAME: 1,
  COURSE_IDENTIFIER: 2,
  EXPENSE_DESCRIPTION: 3,
  LOCATION: 4,
  PROVIDER_NAME: 5,
  BUSINESS_JUSTIFICATION: 6,
  START_END_DATE: 7,
  PAYMENT_DATE_AMOUNT: 8,
  COURSE_GRADE: 9,
  RECEIPT: 10,
  PAYMENT_DATE_PROOF: 11,
  REGISTRATION_PROOF: 12,
  COMPLETION_PROOF: 13,
  EVENT_DESCRIPTION: 14,
  SUPPORTING_DOCUMENTS: 15
}; // corresponds with server enum ReimbursementEventSubmissionStatus.cs

exports.REIMBURSEMENT_EVENT_REQUIREMENT_TYPE = REIMBURSEMENT_EVENT_REQUIREMENT_TYPE;
var REIMBURSEMENT_EVENT_SUBMISSION_STATUS = {
  PENDING: 0,
  READY_FOR_REIMBURSEMENT: 1,
  MARK_AS_PAID: 2
}; // corresponds with server enum ReimbursementRequirementType.cs

exports.REIMBURSEMENT_EVENT_SUBMISSION_STATUS = REIMBURSEMENT_EVENT_SUBMISSION_STATUS;
var REIMBURSEMENT_REQUIREMENT_TYPE = {
  SUBMISSION: 0,
  DOCUMENT: 1
}; // corresponds with server enum CourseGrade.cs

exports.REIMBURSEMENT_REQUIREMENT_TYPE = REIMBURSEMENT_REQUIREMENT_TYPE;
var COURSE_GRADE = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  F: 4,
  PASS: 5,
  FAIL: 6
}; // corresponds with server enum GradeType.cs

exports.COURSE_GRADE = COURSE_GRADE;
var GRADE_TYPE = {
  LETTER: 0,
  PASS_FAIL: 1,
  OTHER: 2
};
exports.GRADE_TYPE = GRADE_TYPE;
var URLS = {
  // Please note that this is a bit of a misnomer - this will re-direct to the "home"
  // of the current portal. Used instead of creating MARKETING.HOME, MEMBER.HOME, etc.
  HOME: "/",
  LOGIN: "/login",
  LOGOUT: "/logout",
  PROFILES: "/session/accounts",
  RESET_PASSWORD: "/reset",
  RESEND_INVITATION: "/resend-invitation",
  GO: "/go",
  MARKETING: {
    CONTACT: "/contact",
    PRODUCTS: "/products",
    PAYDOWN: "/student-loan-paydown",
    SAVEUP: "/college-saveup",
    REFI: "/refinance",
    ABOUT: "/about",
    CAREERS: "/careers",
    EMPLOYEES: "/employees",
    PRIVACY_POLICY: "/privacy",
    WEBSITE_TERMS: "/website-terms",
    MEMBER_TERMS: "/terms",
    NOTEBOOK: "/notebook",
    PLAN_INFO_529: "529-plan-information"
  },
  MEMBER: {
    COUNSELING: "/member/counseling",
    ADD_LOAN: "/member/loans/add",
    ADD_529: "/member/529s/add",
    CONNECT_LOAN: "/member/loans/connect",
    RECONNECT_LOAN: "/member/loans/connect?reconnect=true",
    PLAN_INFO_529: "/member/529-plan-information",
    REFINANCING: "/member/refinancing",
    REFI_THINGS_TO_CONSIDER: "/member/refinancing#things-to-consider",
    PRODUCT_VISIBILITY: "/member/profile#product_visibility",
    ASA: "/member/counseling",
    LEARNING_CENTER: "/member/learning",
    PSLF: "/member/pslf",
    DASHBOARD: "/member/dashboard",
    CONTACT: "/member/help#contact_us",
    PROFILE: "/member/profile",
    NOTIFICATIONS: "/member/notifications",
    REGISTER: "/member/register",
    MY_ACCOUNTS: "/member/my-accounts",
    MY_ACCOUNTS_MATCH: "/member/my-accounts#match",
    MY_ACCOUNTS_MATCH_UPLOADER: "/member/my-accounts?openMatchUploader=true",
    MY_ACCOUNTS_TUITION: "/member/my-accounts#reimbursement",
    MY_ACCOUNTS_TUITION_UPLOADER: "/member/my-accounts?openReimbursementUploader=true",
    MY_ACCOUNTS_HISTORY: "/member/my-accounts#history"
  },
  EMPLOYER: {
    DASHBOARD: "/employer/dashboard",
    PARTICIPANTS: "/participant",
    PARTICIPANT_DETAIL: "/participant/detail",
    MANAGE_REFI: "/",
    MANAGE_PROGRAMS: "/program",
    PROGRAM_EDIT: "/program/edit",
    PROGRAM_DETAIL: "/program/detail",
    PROGRAM_SELECT: "/program/select",
    REPORTS: "/report",
    FUNDING: "/employer/profile#funding",
    PROFILE_AUTO_APPROVAL: "/employer/profile#auto_approval",
    PROFILE_PLAN_INFORMATION: "/employer/profile#plan_information",
    PROFILE_COMPANY_DETAILS: "/employer/profile#company_details",
    PROFILE: "/employer/profile",
    STATEMENT_DETAIL: "/statement/detail",
    STATEMENT_INDEX: "/statement/index",
    CONTACT: "/employer/help#contact_us",
    REQUESTS: "/employer/requests"
  },
  INTRANET: {
    ENTITIES: "/entity",
    ENTITY_BULK_EDIT: "/entity/bulk-edit",
    ENTITY_SLUGS: "/entity/slug/index",
    USERS: "/user",
    USER_DETAIL: "/user/detail",
    REPORTING: "/reporting",
    SERVICERS: "/servicer",
    SERVICER_ADDRESSES: "/servicer-address/index?validationstatus=0",
    SERVICER_SCRUB_FILE: "/servicer/scrub-file",
    LENDERS: "/lender",
    SAVEUP_PLANS: "/saveup",
    TRANSACTIONS: "/payable",
    REVIEW: "/review/index",
    REVIEW_CHANGEREQUESTS: "/review/change-requests",
    REVIEW_TRANSACTIONS: "/review/transactions",
    REVIEW_SAVEUP: "/review/saveup",
    REVIEW_LOAN: "/review/loan",
    REVIEW_SPINWHEEL_LOAN: "/review/spinwheel-loan",
    REVIEW_SERVICER_ADDRESS_MAPPING: "/review/servicer-address-mapping",
    REVIEW_MATCH_PAYMENT: "/review/match-payment-validation",
    REVIEW_SPINWHEEL_PAYMENT_TYPE_MAPPING: "/review/spinwheel-payment-type-mapping",
    SPINWHEEL_USER_OVERVIEW: "/spinwheel/user-overview",
    JOBS: "/job",
    CALENDAR: "/calendar",
    REFERRALS: "/referral",
    SETTINGS: "/configuration",
    EMAIL_TEST: "/email-test"
  },
  INFRASTRUCTURE: {
    SERVERS: "/",
    URLS: "/urls"
  },
  API: {
    OFFER: {
      LENDKEY_CALCULATOR: "/api/offer/lendkey/calculator"
    }
  },
  EXTERNAL: {
    SPINWHEEL: {
      CONSUMER_LEGAL: "https://legal.spinwheel.io/"
    },
    HELP: {
      MEMBER: "https://support.vestwell.com/hc/en-us/sections/21280657728023-Employees",
      EMPLOYER: "https://support.vestwell.com/hc/en-us/sections/18377169795863-Employers"
    },
    ADDITION: {
      UNDERSTAND_LOANS: "https://app.additionwealth.com/courses/student-loans/b9db5d56-a1e2-4397-821b-4044c7152256",
      PAYING_LOANS: "https://app.additionwealth.com/articles/6626687b-bf81-420e-aa5b-35ed894800b2"
    },
    PSLF: {
      CHECK_MY_ELIGIBILITY: "https://studentaid.gov/manage-loans/forgiveness-cancellation/public-service#qualify",
      LEARN_MORE_ABOUT_PSLF: "https://studentaid.gov/manage-loans/forgiveness-cancellation/public-service",
      SUBMIT_ECF_FORM: "https://studentaid.gov/fsa-id/sign-in/landing?redirectTo=%2Faid-summary%2Fpublic-service-loan-forgiveness-payments%2Femployment-certification",
      CHECK_PAYMENT_STATUS: "https://studentaid.gov/fsa-id/sign-in/landing?redirectTo=%2Faid-summary%2Fpublic-service-loan-forgiveness-payments",
      APPLY_FOR_PSLF_FORGIVENESS: "https://studentaid.gov/pslf/",
      LEARN_ABOUNT_CONSOLIDATION: "https://studentaid.gov/loan-consolidation/",
      CHECK_YOUR_REPAYMENT_PLAN: "https://studentaid.gov/manage-loans/forgiveness-cancellation/public-service#qualifying-repayment-plans",
      TRACK_YOUR_PSLF_PROGRESS: "https://studentaid.gov/fsa-id/sign-in/landing"
    }
  }
};
exports.URLS = URLS;
var KEYCODES = {
  ENTER: 13
};
exports.KEYCODES = KEYCODES;
var JOB_TYPE = {
  NONE: 0,
  FED_ACH_ETL: 1,
  USER_ACCOUNT_SUMMARY_NOTIFICATIONS: 2,
  INVOICE_POST: 3,
  ELIGIBILITY: 4,
  GENERATE_CHECKS: 5,
  UPLOAD_PAYMENTS: 6,
  RECEIVABLE_GENERATOR: 7,
  PAYMENT_ACKNOWLEDGMENT: 8,
  SLP_USER_TRANSACTION_GENERATOR: 9,
  USER_PAYABLES_GENERATOR: 10,
  INVOICE_POLL: 11,
  IMPUTED_INCOME: 12,
  PAYMENT_NOTIFIER: 13,
  EDI: 14,
  GENERATE_PAYMENTS: 15,
  REFI_FILE_PROCESSOR: 16,
  SERVICER_PAYABLE_GENERATOR: 17,
  DEBIT_OPEN_CLOSE: 18,
  DEBIT: 19,
  DEBIT_RECONCILIATION: 20,
  SCRUB_FILE_RESPONSE: 21,
  DEBIT_APPLICATION_STATUS: 22,
  DAILY_LIABILITY_REPORT: 23,
  RESPONSYS_MEMBER_EXPORT: 24,
  RESPONSYS_EMPLOYER_ADMIN_EXPORT: 25,
  RESPONSYS_SALESFORCE_MERGE: 26,
  RESPONSYS_INVITATION_EXPORT: 27,
  GET_FRB_DATA: 28,
  INDEX_USER_ACCOUNTS: 29,
  OFAC: 30,
  ADP: 31,
  RESPONSYS_DEFERRED_REGISTRATION_EXPORT: 32,
  EMAIL: 33,
  ASCENSUS_VALIDATION_FILE: 34,
  ASCENSUS_TRANSACTION_ACK_FILE: 35,
  UPDATE_LOAN_AMOUNT_BALANCES: 36,
  PAYROLL_DEDUCTION_REQUEST: 37,
  PAYROLL_DEDUCTION: 38,
  POLL_PAYROLL_DEDUCTION_ACTUALS_FILE: 39,
  SEND_MATCH_REMINDERS: 40,
  LOCKBOX_FILE: 41,
  MATCH_LOAN_REMINDER: 42,
  GENERATE_ACH_DEBIT_REQUEST_FILE: 43,
  ACH_DEBIT_PAYMENT_ACKNOWLEDGMENT: 44,
  MATCH_PAYMENT_OVERVIEW: 45,
  SEND_REFI_BONUS_REMINDERS: 46,
  UNAPPROVED_STATEMENTS_NOTIFICATION: 47,
  GET_FAILED_MESSAGE_REQUEST_INFO: 48,
  RESEND_FAILED_MESSAGE_REQUESTS_BY_DATE: 49,
  SPINWHEEL_DISCONNECT_ACCOUNTS: 50,
  SPINWHEEL_UPDATE_CONNECTED_USERS: 51,
  SPINWHEEL_SERVICERS: 52,
  ACKNOWLEDGE_PAYMENT_SUBMISSIONS_FROM_SIERRA: 53,
  SEND_SIERRA_PAYMENT_SUBMISSIONS: 54
};
exports.JOB_TYPE = JOB_TYPE;
var _default = {
  EMPTY_GUID: EMPTY_GUID,
  SYSTEM_USER_GUID: SYSTEM_USER_GUID,
  REFI_MAXIMUM_REWARD: REFI_MAXIMUM_REWARD,
  FORM_SUBMIT_DEBOUNCE_MS: FORM_SUBMIT_DEBOUNCE_MS,
  DEFAULT_CONFIG_SET_ALT_ID: DEFAULT_CONFIG_SET_ALT_ID,
  TRANSPARENT_PIXEL_SRC: TRANSPARENT_PIXEL_SRC,
  CITIZENS_PROGRAM_ALT_ID: CITIZENS_PROGRAM_ALT_ID,
  CITIZENS_OFFER_ALT_ID: CITIZENS_OFFER_ALT_ID,
  RADIUS_PROGRAM_ALT_ID: RADIUS_PROGRAM_ALT_ID,
  FRB_OFFER_ALT_ID: FRB_OFFER_ALT_ID,
  LENDKEY_OFFER_ALT_ID: LENDKEY_OFFER_ALT_ID,
  LENDKEY_PROGRAM_ALT_ID: LENDKEY_PROGRAM_ALT_ID,
  EARNEST_OFFER_ALT_ID: EARNEST_OFFER_ALT_ID,
  EARNEST_PROGRAM_ALT_ID: EARNEST_PROGRAM_ALT_ID,
  LENDER_EARNEST: LENDER_EARNEST,
  LENDER_LENDKEY: LENDER_LENDKEY,
  LENDER_FRB: LENDER_FRB,
  PROGRAM_DROPDOWN_YEARS: PROGRAM_DROPDOWN_YEARS,
  EMPLOYER_LAUNCH_STATE: EMPLOYER_LAUNCH_STATE,
  REFI_SETUP_STATUS: REFI_SETUP_STATUS,
  PAYMENT_ACCOUNT_TYPES: PAYMENT_ACCOUNT_TYPES,
  PROGRAM_TYPES: PROGRAM_TYPES,
  PRODUCT_TYPES: PRODUCT_TYPES,
  PROGRAM_SETUP_STATE: PROGRAM_SETUP_STATE,
  ONBOARDING_STEP: ONBOARDING_STEP,
  MATCH_SUBMISSION_STEP: MATCH_SUBMISSION_STEP,
  PARTICIPANT_ENROLLMENT_STATUS: PARTICIPANT_ENROLLMENT_STATUS,
  EMPLOYER_COMMUNICATION_TYPES: EMPLOYER_COMMUNICATION_TYPES,
  ACCEPTED_UPLOAD_FILE_TYPES: ACCEPTED_UPLOAD_FILE_TYPES,
  SERVICER_TYPE: SERVICER_TYPE,
  KEYCODES: KEYCODES,
  FREQUENCY_UNIT: FREQUENCY_UNIT,
  TABLE_PAGE_SIZES: TABLE_PAGE_SIZES,
  CHANGE_REQUEST_STATUS: CHANGE_REQUEST_STATUS,
  CHANGE_REQUEST_TYPE: CHANGE_REQUEST_TYPE,
  PRODUCT_MODEL_STATE: PRODUCT_MODEL_STATE,
  USER_NOTIFICATION_TYPE: USER_NOTIFICATION_TYPE,
  META_TAG_TYPES: META_TAG_TYPES,
  SPINWHEEL_PAYMENT_TYPE_STATUS: SPINWHEEL_PAYMENT_TYPE_STATUS,
  JOB_TYPE: JOB_TYPE,
  REIMBURSEMENT_EVENT_TYPE: REIMBURSEMENT_EVENT_TYPE,
  REIMBURSEMENT_EVENT_REQUIREMENT_TYPE: REIMBURSEMENT_EVENT_REQUIREMENT_TYPE,
  REIMBURSEMENT_EVENT_SUBMISSION_STATUS: REIMBURSEMENT_EVENT_SUBMISSION_STATUS,
  REIMBURSEMENT_REQUIREMENT_TYPE: REIMBURSEMENT_REQUIREMENT_TYPE
};
exports.default = _default;